// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip-module__tooltip__4Wc9o","content":"Tooltip-module__content__XswRm","title":"Tooltip-module__title__i3ppw","text":"Tooltip-module__text__gDf0a"};